import {
  UserGroupIcon,
  CalendarDaysIcon,
  ChatBubbleBottomCenterTextIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline'
import { Link, Navigate } from 'react-router-dom'
import BreadCrumb from '../BreadCrumb';
import { useAuth } from '../Auth/Auth';


const pages = [
  { name: 'Customer Care', to: '/customers', component: Link, current: true },


];


  const actions = [

    {
      title: 'Customer Admin',
      to: '/customers/manage',
      desc: "Create, Edit and Delete Customer Data",
      component: Link,
      icon: UserGroupIcon,
      iconForeground: 'text-white',
      iconBackground: 'bg-gradient-to-br from-purple-500 to-indigo-600',
    },


    {
      title: 'Schedule Appointments',
      to: '/customers/appointments',
      desc: "Create, Modify Customer Appointment Dates",
      component: Link,
      icon: CalendarDaysIcon,
      iconForeground: 'text-white',
      iconBackground: 'bg-gradient-to-br from-blue-500 to-cyan-600',
    },


    {
        title: 'Feedback Management',
        to: '/customers/feedback',
        icon: ChatBubbleBottomCenterTextIcon,
        component: Link,
        desc: "Allows customers to submit feedback or complaints",
        iconForeground: 'text-white',
        iconBackground: 'bg-gradient-to-br from-emerald-500 to-teal-600',
      },




    {
        title: 'Customer Analytics',
        to: '/customers/reports',
        desc: "Reports on Customer Data",
        icon: ChartBarIcon,
        iconForeground: 'text-white',
        iconBackground: 'bg-gradient-to-br from-rose-500 to-pink-600',
      },












  ]
  
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }



const CustomerPage = () => {
  const { role, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Loading...</p>
        </div>
      </div>
    );
  }

  if (role !== 'Customer Care' && role !== 'Admin' && role !== 'Service Advisor') {

    return <Navigate to="/unauthorized" replace />;
  }


  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <BreadCrumb pages={pages} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-3">
            Customer Care Management
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive tools to manage customer relationships, appointments, feedback, and analytics
          </p>
        </div>

        {/* Navigation Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {actions.map((action) => (
            <Link
              key={action.title}
              to={action.to}
              className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden"
            >
              {/* Gradient Background Overlay */}
              <div className="absolute inset-0 bg-gradient-to-br from-transparent to-gray-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

              {/* Card Content */}
              <div className="relative p-8">
                {/* Icon Container */}
                <div className="flex items-center justify-center mb-6">
                  <div
                    className={classNames(
                      action.iconBackground,
                      'rounded-2xl p-4 shadow-lg transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3'
                    )}
                  >
                    <action.icon className={classNames(action.iconForeground, "h-8 w-8")} aria-hidden="true" />
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-center text-gray-900 mb-3 group-hover:text-indigo-600 transition-colors duration-200">
                  {action.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-center text-gray-600 leading-relaxed">
                  {action.desc}
                </p>

                {/* Arrow Icon */}
                <div className="absolute bottom-6 right-6 text-gray-400 group-hover:text-indigo-600 transition-colors duration-200">
                  <svg className="h-6 w-6 transform group-hover:translate-x-1 transition-transform duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </div>
              </div>

              {/* Bottom Accent Bar */}
              <div className={classNames(
                action.iconBackground,
                "absolute bottom-0 left-0 right-0 h-1 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"
              )}></div>
            </Link>
          ))}
        </div>

        {/* Quick Stats Section (Optional Enhancement) */}
        <div className="mt-16 bg-white rounded-2xl shadow-lg p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Quick Access
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Link
              to="/customers/manage"
              className="group text-center p-6 bg-gradient-to-br from-purple-50 to-indigo-50 rounded-xl hover:shadow-lg transition-all duration-200 hover:scale-105 cursor-pointer"
            >
              <p className="text-sm font-medium text-gray-600 mb-1">Total Customers</p>
              <p className="text-3xl font-bold text-indigo-600 group-hover:text-indigo-700">View All</p>
            </Link>
            <Link
              to="/customers/appointments"
              className="group text-center p-6 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl hover:shadow-lg transition-all duration-200 hover:scale-105 cursor-pointer"
            >
              <p className="text-sm font-medium text-gray-600 mb-1">Today's Appointments</p>
              <p className="text-3xl font-bold text-blue-600 group-hover:text-blue-700">Schedule</p>
            </Link>
            <Link
              to="/customers/feedback"
              className="group text-center p-6 bg-gradient-to-br from-emerald-50 to-teal-50 rounded-xl hover:shadow-lg transition-all duration-200 hover:scale-105 cursor-pointer"
            >
              <p className="text-sm font-medium text-gray-600 mb-1">Pending Feedback</p>
              <p className="text-3xl font-bold text-emerald-600 group-hover:text-emerald-700">Manage</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomerPage